'use client';
import appConfig from '@nerdwallet/app-config';
import { InitCompass } from '@nerdwallet/compass/next-init-compass';
import { useAnalyticsContext } from './useAnalyticsContext';

export const InitCompassWithContext = () => {
  const { pageViewId } = useAnalyticsContext();

  return (
    <InitCompass
      writeKey={appConfig?.SEGMENT?.WRITE_KEY ?? ''}
      deployableName={appConfig?._meta?.deployable ?? 'my-nerdwallet-next'}
      deployableVersion={appConfig?._meta?.version ?? '0.0.0'}
      pageViewId={pageViewId}
    />
  );
};
